import {
  index as baseIndex,
  getFromId as baseGetFromId,
  editFromId as baseEditFromId,
  newItem as baseNewItem
 } from './Base';

/******************************************************************************
 * INDEX FUNCTION                                                             *
 ******************************************************************************/

/**
 * Get a list of ticket forms based on a pagination system
 *
 * @param page the page requested
 * @param itemPerPage the number of item in the page requested
 */
export function index(identifier) {
  return function index(page = 1, itemPerPage = 10, search = {}, order = 'ASC', scheme = null){
    return baseIndex('ticket_forms/'+identifier, page, itemPerPage, search, order, scheme);
  }
}

/******************************************************************************
 * GETTER FUNCTION                                                            *
 ******************************************************************************/

/**
 * Get a single ticket form based on his ID
 *
 * @param id the of the ticket form requested
 */
export function getFromId(identifier) {
  return function (id) {
    return baseGetFromId('ticket_forms/'+identifier, id);
  }
}

/**
 * Get a single product based on his ID
 *
 * @param id the of the product requested
 */
export function getIdentificationDataFromId(identifier) {
  return function (id) {
    return baseGetFromId('ticket_forms/'+identifier, id, 'id');
  }
}

/******************************************************************************
 * SETTER FUNCTION                                                            *
 ******************************************************************************/

/**
 * Edit a single ticket form based on his ID
 *
 * @param id the of the ticket form requested
 * @param data the new data of the ticket form
 */
export function editFromId(identifier) {
  return function (id, data) {
    return baseEditFromId('ticket_forms/'+identifier, id, data);
  }
}

/******************************************************************************
 * NEW FUNCTION                                                               *
 ******************************************************************************/

/**
 * Create a new ticket form
 *
 * @param data the new data of the partner
 */
export function newItem(identifier) {
  return function (data) {
    return baseNewItem('ticket_forms/'+identifier, data);
  }
}

/******************************************************************************
 * FETCH FUNCTION                                                             *
 ******************************************************************************/

/**
 * Get the complete list of ticket forms
 */
export function fetchTicketForms(identifier) {
  return function (){
    return baseIndex('ticket_forms/'+identifier, 1, 0);
  }
}
